// Pure helpers for server-side paginated list queries (accounts/contacts).
// Kept free of Supabase imports so they can be unit-tested in the node env.

export const DEFAULT_PAGE_SIZE = 50

/** Inclusive row window for supabase .range() */
export function pageRange(pageIndex: number, pageSize: number): { from: number; to: number } {
  const from = pageIndex * pageSize
  return { from, to: from + pageSize - 1 }
}

export function pageCount(total: number, pageSize: number): number {
  return total <= 0 ? 0 : Math.ceil(total / pageSize)
}

/** Whitespace-split search input into terms; every term must match (AND). */
export function searchTerms(raw: string): string[] {
  return raw.split(/\s+/).filter(Boolean)
}

/**
 * Escape LIKE wildcards so user input matches literally (client-side
 * filtering used plain substring match), then wrap in %…% for ilike.
 */
export function ilikePattern(term: string): string {
  return `%${term.replace(/[\\%_]/g, (c) => `\\${c}`)}%`
}

/**
 * Build a PostgREST or() filter matching one term against several columns.
 * Values are double-quoted so commas/parens in the term can't break the
 * logic-tree syntax; embedded quotes and backslashes are escaped.
 */
export function orIlike(columns: readonly string[], term: string): string {
  const pattern = ilikePattern(term)
  const quoted = `"${pattern.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`
  return columns.map((col) => `${col}.ilike.${quoted}`).join(',')
}
